import { UID } from 'shared/api/query/constants';
import { customerContract as customerContractConfig } from 'shared/api/query/configs.json';

export const customerContractEdges = [
  { attr: UID },
  { attr: customerContractConfig.edges.signedAt },
  { attr: customerContractConfig.edges.startedAt },
  { attr: customerContractConfig.edges.canceledAt },
  { attr: customerContractConfig.edges.accountType },
  { attr: customerContractConfig.edges.stripeId, default: '' },
];
